const getStyles = () => {
  return {
    section: {
      padding: '80px 0',
      '@media (max-width: 768px)': {
        padding: '60px 0'
      }
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px'
    },
    title: {
      fontWeight: '700',
      fontSize: '48px',
      lineHeight: '1.2',
      textAlign: 'center',
      marginBottom: '24px',
      color: '#000000',
      '@media (max-width: 768px)': {
        fontSize: '36px'
      }
    },
    primaryText: {
      background:
        'linear-gradient(135deg, #0c5adb 0%, #3a8ef6 50%, #8a2be2 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      backgroundSize: '200% 200%',
      fontSize: '35px'
    },
    cardsContainer: {
      display: 'grid',
      gap: '24px',
      marginBottom: '48px',
      '@media (min-width: 768px)': {
        gridTemplateColumns: 'repeat(2, 1fr)'
      },
      '@media (min-width: 1024px)': {
        gridTemplateColumns: 'repeat(3, 1fr)'
      }
    },
    card: {
      border: '2px solid rgba(55, 128, 237, 0.2)',
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        border: '2px solid #0c5adb',
        boxShadow: '0 0 20px rgba(55, 128, 237, 0.3)'
      }
    },
    cardContent: {
      padding: '32px',
      textAlign: 'center'
    },
    iconContainer: {
      width: '64px',
      height: '64px',
      backgroundColor: 'rgba(150, 180, 220, 0.1)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 16px auto'
    },
    cardIcon: {
      width: '32px',
      height: '32px',
      color: '#0c5adb'
    },
    cardTitle: {
      fontSize: '22px',
      fontWeight: '700',
      marginBottom: '12px',
      color: '#000000'
    },
    cardDescription: {
      fontSize: '16px',
      color: 'rgba(0,0,0,0.6)',
      lineHeight: '1.5'
    },
    note: {
      padding: '24px',
      backgroundColor: 'rgba(150, 180, 220, 0.1)',
      border: '2px solid rgba(150, 180, 220, 0.3)',
      borderRadius: '12px',
      textAlign: 'center',
      maxWidth: '800px',
      margin: '0 auto'
    },
    noteText: {
      fontSize: '18px',
      fontWeight: '500',
      color: '#000000'
    }
  };
};

export default getStyles;
